import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fb3d7ac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "kefu" }
const _hoisted_2 = { class: "kefu-way" }
const _hoisted_3 = ["onClick", "onMouseenter"]
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "免费咨询电话")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-content" }, "400-088-0991", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.wayList, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "way-item",
          key: index,
          onClick: ($event: any) => (_ctx.goWayToLink(index)),
          onMouseenter: ($event: any) => (_ctx.kefuWay(index)),
          onMouseleave: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideDetail && _ctx.hideDetail(...args)))
        }, [
          _createElementVNode("img", {
            src: require(`../../../public/img/home/${item.img}`),
            alt: item.name
          }, null, 8, _hoisted_4),
          _createElementVNode("p", null, _toDisplayString(item.name), 1)
        ], 40, _hoisted_3))
      }), 128)),
      _withDirectives(_createElementVNode("div", {
        class: "phonr-detail",
        onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearTimer && _ctx.clearTimer(...args))),
        onMouseout: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.hideDetail && _ctx.hideDetail(...args)))
      }, _hoisted_8, 544), [
        [_vShow, _ctx.wayIndex === 0]
      ])
    ])
  ]))
}